import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RodapeLoginComponent } from '../rodape-login/rodape-login.component';
import { SolaryumPageComponent } from "../components/ui/solaryum-page";
import { RouterModule } from "@angular/router";
import { IMaskModule } from "angular-imask";


@NgModule({
  declarations: [
    SolaryumPageComponent,
    RodapeLoginComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    IMaskModule,
  ],
  exports: [
    RodapeLoginComponent,
    SolaryumPageComponent
  ]
})
export class ComumModule { }
